export default __webpack_public_path__ + "static/media/count.4aaac6f5.svg";